/* import __COLOCATED_TEMPLATE__ from './config-side-sheet.hbs'; */
/* RESPONSIBLE TEAM: team-workflows */
import templateOnlyComponent from '@ember/component/template-only';

interface Args {
  isOpen: boolean;
  onClose: () => void;
  isReadOnly: boolean;
  className?: string;
  title: string;
  body: any;
}

interface Signature {
  Element: HTMLDivElement;
  Args: Args;
}

const ConfigSideSheet = templateOnlyComponent<Signature>();
export default ConfigSideSheet;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Workflows::GraphEditor::NodeItems::Steps::Fin::Sections::HandoffToExternalTicketOnResolution::ConfigSideSheet': typeof ConfigSideSheet;
    'workflows/graph-editor/node-items/steps/fin/sections/handoff-to-external-ticket-on-resolution/config-side-sheet': typeof ConfigSideSheet;
  }
}
